import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { X, Globe } from "lucide-react";

const STORAGE_KEY = "nibro_i18n_beta_dismissed_v1";

/**
 * Smal informatie-banner die alleen verschijnt wanneer de actieve taal
 * niet Nederlands is. Communiceert eerlijk dat de andere talen een
 * machinevertaling zijn en dat sommige pagina's nog NL kunnen tonen.
 */
export default function I18nBetaBanner() {
  const { i18n, t } = useTranslation();
  const lang = (i18n.language || "nl").split("-")[0];
  const [dismissed, setDismissed] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.localStorage.getItem(STORAGE_KEY) === "1";
  });

  if (lang === "nl" || dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try { window.localStorage.setItem(STORAGE_KEY, "1"); } catch { /* noop */ }
  };

  return (
    <div
      className="w-full border-b border-amber-200 bg-amber-50 px-4 py-2 text-xs text-amber-900"
      data-testid="i18n-beta-banner"
      role="status"
    >
      <div className="mx-auto flex max-w-[1400px] items-center gap-3">
        <Globe size={14} className="flex-shrink-0 text-amber-700" />
        <p className="flex-1 leading-snug">{t("header.beta_banner")}</p>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Sluit melding"
          data-testid="i18n-beta-banner-close"
          className="flex-shrink-0 rounded p-1 transition hover:bg-amber-100"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
